<template>
  <div class="e-overall e-overall--login e-register">
    <transition name="slide-to-left">
      <div v-show="!offcanvasOpen" class="e-canvas">
        <div v-if="!$route.meta.requiresAuth" class="e-canvas__background" />

        <TheHeader />
        <div class="e-content width-100">
          <div class="e-scroll-container">
            <VuePerfectScrollbar class="e-content__inner center-content">
              <div class="e-content__scroll">
                <div
                  class="e-module e-module--limited  e-login-container"
                >
                  <RegisterForm />
                </div>
              </div>
              <TheFooter class="e-register-footer" />
            </VuePerfectScrollbar>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-from-right">
      <TheOffcanvas v-show="offcanvasOpen" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TheFooter from 'molecules/TheFooter/TheFooter'
import TheHeader from 'molecules/TheHeader/TheHeader'
import TheOffcanvas from 'molecules/TheOffcanvas/TheOffcanvas'
import RegisterForm from 'organisms/Forms/Register/Registerform'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    TheFooter,
    TheHeader,
    TheOffcanvas,
    RegisterForm,
    VuePerfectScrollbar
  },
  computed: {
    ...mapGetters(['offcanvasOpen', 'userInfo'])
  }
}
</script>
<style lang="scss">
.e-register {
  .e-register-footer {
    padding-top: 2rem;
  }

  .e-content__scroll {
    padding: 1rem;
  }

  .e-content__inner {
    @include break(l) {
      gap: 4rem;
    }
  }
}
</style>
